/* Funcao que transforma o tipo modelo em uma rota */
export default function(tipModelo) {
  const map = {
    1: "um",
    2: "dois",
    3: "quatro",
    4: "oito",
    5: "info"
  };
  return map[tipModelo];
}
